// src/components/CaseStudies/CaseStudiesIndex.tsx
import type { CaseStudy } from "../../data/caseStudies";

interface CaseStudiesIndexProps {
  caseStudies: CaseStudy[];
  selectedId: string | null;
  onSelect: (id: string) => void;
}

const CaseStudiesIndex: React.FC<CaseStudiesIndexProps> = ({
  caseStudies,
  selectedId,
  onSelect,
}) => {
  return (
    <div className="surface-card divide-y divide-line">
      {caseStudies.map((cs) => {
        const isActive = cs.id === selectedId;
        return (
          <button
            key={cs.id}
            type="button"
            onClick={() => onSelect(cs.id)}
            className={`w-full text-left px-5 py-5 border-l-2 transition-colors ${
              isActive
                ? "bg-surface-2 border-signal"
                : "bg-transparent border-transparent hover:bg-surface-2 hover:border-line-strong"
            }`}
          >
            <p
              className={`kicker mb-1.5 ${isActive ? "text-signal" : ""}`}
            >
              {cs.sector}
            </p>
            <h3 className="font-display text-sm sm:text-base font-semibold text-ink mb-1.5">
              {cs.title}
            </h3>
            <p className="text-xs text-muted mb-2">
              {cs.client} · {cs.location ?? "Global"}
            </p>
            <p className="text-xs text-muted line-clamp-3 mb-3">
              {cs.summary}
            </p>
            <div className="flex flex-wrap gap-1.5">
              {cs.tags.slice(0, 4).map((tag) => (
                <span key={tag} className="tag-chip">
                  {tag}
                </span>
              ))}
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default CaseStudiesIndex;
